'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import type { ChangeEvent } from 'react';
import { FillScreen, HStack } from '@/components/Layout';
import SearchInput from '@/components/SearchInput';
import { useDebouncedCallback } from '@/hooks/useDebouncedCallback';
import { stacktraceNS, useTranslation } from '@/lib/i18n';
import { RoadmapGanttPanel } from './-gantt/RoadmapGanttPanel';
import { RoadmapGanttPhaseTabs } from './-gantt/RoadmapGanttPhaseTabs';
import { RoadmapGanttSearchSchema } from './-zod-schema';
export const Route = createFileRoute('/_stacktrace/product-roadmap/$roadmapId/_layout/detail/')({
  validateSearch: zodValidator(RoadmapGanttSearchSchema),
  component: RoadmapDetailPage
});
function RoadmapDetailPage() {
  const {
    t
  } = useTranslation(stacktraceNS, {
    keyPrefix: 'productRoadmap.detail.gantt'
  });
  const {
    phase,
    freeText
  } = Route.useSearch();
  const navigate = Route.useNavigate();
  const handleFilterInput = useDebouncedCallback((e: ChangeEvent<HTMLInputElement>) => navigate({
    search: prev => ({
      ...prev,
      freeText: e.target.value
    })
  }), [navigate]);
  return <FillScreen className="flex flex-col gap-4 px-12 py-5">
      <HStack className="gap-2 items-center">
        <RoadmapGanttPhaseTabs />
      </HStack>
      <HStack className="items-center pl-3 pr-2 py-2 rounded-lg bg-neutral-fill outline-solid outline-1 outline-neutral-muted-border shadow-md">
        <SearchInput className="w-56 h-8 shrink-0" placeholder={t('searchPlaceholder')} defaultValue={freeText} onChange={handleFilterInput} />
      </HStack>
      <div className="flex min-h-0 flex-1 overflow-hidden rounded-lg bg-neutral-fill outline-solid outline-1 outline-neutral-muted-border shadow-md">
        <RoadmapGanttPanel phase={phase} keyword={freeText ?? ''} />
      </div>
    </FillScreen>;
}